
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/mallcategory/[code]",
      function () {
        return require("private-next-pages/parts/mallcategory/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/mallcategory/[code]"])
      });
    }
  